import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Patient = ApiSchemas['PatientPresenter']

export type AssignedSex = NonNullable<Patient['assignedSex']>
export const AssignedSex = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  INTERSEX: 'INTERSEX',
  NO_ANSWER: 'NO_ANSWER',
} satisfies Record<AssignedSex, AssignedSex>

export type Ethnicity = NonNullable<Patient['ethnicity']>
export const Ethnicity = {
  BLACK: 'BLACK',
  BROWN: 'BROWN',
  INDIGENOUS: 'INDIGENOUS',
  WHITE: 'WHITE',
  YELLOW: 'YELLOW',
} satisfies Record<Ethnicity, Ethnicity>

export type PatientHeightHistory = ApiSchemas['PatientHeightHistoryPresenter']

export type PatientWeightHistory = ApiSchemas['PatientWeightHistoryPresenter']

export default {
  async existsByCpf(params: ApiSchemas['FindPatientByCpfDto']) {
    return wrapEndpoint(() =>
      client.GET('/patient/exists-by-cpf/{cpf}/physician/{physicianId}', {
        params: {
          path: params,
        },
      }),
    )
  },
  async getByCpf(params: ApiSchemas['FindPatientByCpfDto']) {
    return wrapEndpoint(() =>
      client.GET('/patient/by-cpf/{cpf}/physician/{physicianId}', {
        params: {
          path: params,
        },
      }),
    )
  },
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/patient/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListPatientDto']) {
    return wrapEndpoint(() =>
      client.GET('/patient', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreatePatientDto']) {
    return wrapEndpoint(() =>
      client.POST('/patient', {
        body,
      }),
    )
  },
  async update(id: number, body: ApiSchemas['UpdatePatientDto']) {
    return wrapEndpoint(() =>
      client.PUT('/patient/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async delete(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/patient/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
